import user from 'assets/image/icons/svg/user.svg'
import { appDay } from 'shared/day.ts'
import { useAppSelector } from 'shared/hooks/store.ts'
import { StackIcon } from 'shared/ui'

import type { Message } from '../../model/types.ts'

import { api } from '../../api.ts'
import { useConversationalist, useCurrentId } from '../../hooks'
import { selectors } from '../../utils/selectors.ts'
import css from './Message.module.css'

export function Seen({ created_at: createdAt, from, message_id: id }: Message) {
	const conversation = useCurrentId()

	const { isLoading } = api.useSeenQuery(conversation)

	const seenMap = useAppSelector(state =>
		selectors.unreadMap(state, conversation)
	)

	const seen = seenMap[id]
	const lastSeen = useAppSelector(state =>
		selectors.lastSeen(state, conversation)
	)

	const conversationalist = useConversationalist()

	const isInterlocutorsMessage = from?.entityId === conversationalist?.entityId

	let showSent = !seen && !isInterlocutorsMessage

	const asDay = appDay(createdAt)

	showSent &&= lastSeen?.isBefore(asDay) ?? true

	let seenLabel = ''

	if (seen) {
		const data = appDay(seen.seen_at).format('MM/DD/YYYY h:mm A')
		seenLabel = `Seen by ${seen.participant.fullName} at ${data}`
	}

	if (showSent) {
		seenLabel = `Sent at ${asDay.format('MM/DD/YYYY h:mm A')}`
	}

	if (isLoading) {
		return null
	}

	if (seen !== undefined) {
		return (
			<img
				alt={seenLabel}
				className={css.seen}
				height={16}
				src={seen.participant.pictureUrl || user}
				title={seenLabel}
				width={16}
			/>
		)
	}

	return (
		showSent && (
			<span className={css.sent}>
				<StackIcon icon='check' label={seenLabel} stack='linkedin' width={12} />
			</span>
		)
	)
}
